import { InstanceType } from 'types/enums/instance';
import { dashboardGeneralPath, workflowListPath } from 'routes/paths';
import { DefaultConfigProps, FontFamily, MenuOrientation, PresetColor, ThemeDirection, ThemeMode } from 'types/config';

export const IS_EFP = process.env.REACT_APP_INSTANCE_TYPE === InstanceType.EFP;
export const APP_DEFAULT_PATH = IS_EFP ? workflowListPath(true) : dashboardGeneralPath(true);
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 260;

export const INSTANCE_TYPE = process.env.REACT_APP_INSTANCE_TYPE as InstanceType;
export const IS_UNDER_CONSTRUCTION = process.env.REACT_APP_UNDER_CONSTRUCTION?.toLocaleLowerCase() === 'true';
export const DOCUMENTATION_URL = process.env.REACT_APP_DOCUMENTATION_URL;
export const GIT_COMMIT_HASH = process.env.REACT_APP_GIT_COMMIT_HASH;
export const GIT_BRANCH_NAME = process.env.REACT_APP_GIT_BRANCH_NAME;
export const KEYCLOAK_URI = process.env.REACT_APP_KEYCLOAK_URI;
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const KEYCLOAK_IDP_HINT = process.env.REACT_APP_KEYCLOAK_IDP_HINT;
export const WORKFLOW_BUILDER_URL = process.env.REACT_APP_WORKFLOW_BUILDER_URL;
export const MEASUREMENT_ID = process.env.REACT_APP_MEASUREMENT_ID;
export const API_URL = process.env.REACT_APP_API_URL;
export const ENV = process.env.REACT_APP_ENV;
export const UNDER_CONSTRUCTION_START_TIME = process.env.REACT_APP_UNDER_CONSTRUCTION_START_TIME;
export const UNDER_CONSTRUCTION_END_TIME = process.env.REACT_APP_UNDER_CONSTRUCTION_END_TIME;
export const REMOTE_FILE_MANAGEMENT_ALLOWED =
    process.env.REACT_APP_REMOTE_FILE_MANAGEMENT_ALLOWED?.toLocaleLowerCase() === 'true';
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;
export const EFP_ALLOCATIONS_URL = process.env.REACT_APP_EFP_ALLOCATIONS_URL;
export const EUROHPC_CALLS_URL = process.env.REACT_APP_EUROHPC_CALLS_URL;

const config: DefaultConfigProps = {
    fontFamily: IS_EFP ? FontFamily.MAVEN_PRO : FontFamily.PUBLIC_SANS,
    i18n: 'en',
    menuOrientation: MenuOrientation.VERTICAL,
    miniDrawer: false,
    container: true,
    firstStart: false,
    mode: ThemeMode.LIGHT,
    presetColor: IS_EFP ? PresetColor.EFP : PresetColor.DEFAULT,
    showGuide: false,
    themeDirection: ThemeDirection.LTR,
    tableOptions: { density: 'spacious' },
    workflowExecutionTab: 'Details',
};

export default config;
